import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ArcoVue from '@arco-design/web-vue'
import '@arco-design/web-vue/dist/arco.css'
import './assets/styles/theme.css'
import './assets/styles/buttons.scss'
import {
    IconRobot,
    IconTrophy,
    IconApps,
    IconSend,
    IconHome,
    IconBook,
    IconHeart,
    IconRight
} from '@arco-design/web-vue/es/icon'

const frontendBuildInfo = {
    buildId: process.env.VUE_APP_BUILD_ID || 'dev',
    buildTime: process.env.VUE_APP_BUILD_TIME || 'dev',
    version: process.env.VUE_APP_BUILD_VERSION || 'dev',
    gitHash: process.env.VUE_APP_GIT_HASH || 'unknown'
}

if (typeof window !== 'undefined') {
    window.__MQ_FRONTEND_BUILD__ = frontendBuildInfo
    console.info('[mq-ai-agent-frontend] build info', frontendBuildInfo)
}

// Create the shared app and store instances.
const pinia = createPinia()
const app = createApp(App)

// Register global Arco icons used across the app.
const icons = [
    IconRobot,
    IconTrophy,
    IconApps,
    IconSend,
    IconHome,
    IconBook,
    IconHeart,
    IconRight
]
icons.forEach(icon => {
    app.component(icon.name, icon)
})

// Pinia must be installed before the router.
app.use(pinia)
app.use(router)
app.use(ArcoVue)

app.mount('#app')
